<template>
  <!-- Holter機器出荷 -->
  <div id="HolterShippingList">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterShippingList"'></holterNavi>
      <div class="labelTitle lable" style="margin-left:0px;">ホルター心電図配送ｻｰﾋﾞｽ 機器出荷</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th><td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>出荷予定日</th><td><input type="date" v-model="searchConditions.shippingDate"/></td>
            <th>送り状番号</th><td><input type="text" v-model="searchConditions.invoiceNumber"/></td>
            <th>ステータス</th><td><select v-model="searchConditions.status"><option v-for="status in statusList" :key="status.code" :value="status.code">{{status.name}}</option></select></td>
          </tr>
          <tr>
            <th>機種</th><td><select v-model="searchConditions.instrumentKind"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            <th>配送先</th><td><select v-model="searchConditions.shippingAddress"><option></option><option value="home">患者宅</option><option value="hospital">医療機関</option></select></td>
            <th>宛名</th><td><input type="text" v-model="searchConditions.receiverName"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area">
        <div class="resultTable-area" v-if="hasResult">
          <div class="result-sub-area">
            <span class="result-count">件数：{{data.length}}件</span>
            <div class="operation-area">
                <b-button class="operationButton is-primary" icon-left="playlist-edit" @click="goPaymentNumberBulkSetting" :disabled="checkedRows.length==0" >着払い番号一括設定</b-button>
                <b-button class="operationButton is-primary" icon-left="microsoft-excel" @click="goInvoiceSheetView" :disabled="checkedRows.length==0">送り状シート作成</b-button>
                <b-button class="operationButton is-primary" icon-left="playlist-edit" @click="goInvoiceBulkSetting" :disabled="checkedRows.length==0">送り状番号一括設定</b-button>
                <b-button class="operationButton is-primary" icon-left="microsoft-excel" @click="goLabel12SheetView" :disabled="checkedRows.length==0">ラベル12シート作成</b-button>
                <b-button class="operationButton is-primary" icon-left="printer" @click="showShippingDirections">出荷指示リスト表示</b-button>
                <b-button class="operationButton is-primary" icon-left="truck-delivery-outline" :disabled="checkedRows.length==0" @click="doShipping">出荷済みにする</b-button>
            </div>
          </div>
          <b-table
              id="shippingListTable"
              :data="data"
              :paginated="isPaginated"
              checkable
              :checked-rows.sync="checkedRows"
              per-page="100"
              pagination-position="both"
              default-sort="reserveTime"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page">
              <template slot-scope="props">
                <b-table-column label="#" width="50" centered>{{props.index +1}}</b-table-column>
                <b-table-column field="hstRequestFlag" label="WP300同梱の有無" width="100" sortable centered >
                  <span v-if="props.row.hstRequestFlag">有</span><span v-else>無</span>
                </b-table-column>
                <b-table-column field="receiptNumber" label="受付番号" width="120" sortable centered>
                  <template v-for="(receiptNumber, index) in props.row.receiptNumber">
                    <router-link v-if="index < 2" :to="{name:'HolterShippingDetail', params:{receiptNumber:props.row.receiptNumber,searchConditions:searchConditions}}" :key="index"><a>{{receiptNumber}}</a></router-link>
                    <br v-if="index < 2" :key="index+'_b'"/>
                    <span v-if="index==3" :key="index+'_c'">･･･</span>
                  </template>
                  <span v-if="props.row.depositMachineFlag" class="depo"/>
                </b-table-column>
                <b-table-column field="units" label="台数" width="50" sortable centered>
                  {{props.row.units}}
                </b-table-column>
                <b-table-column field="reserveTime" label="機器予約コード" width="130" centered sortable>
                  {{props.row.reserveTime}}
                </b-table-column>
                <b-table-column field="shippingDate" label="出荷予定日" width="90" sortable centered>
                  {{props.row.shippingDate }}
                </b-table-column>
                <b-table-column field="invoiceNumber" label="送り状番号" width="100" sortable centered>
                  {{props.row.invoiceNumber }}
                </b-table-column>
                <b-table-column field="paymentNumber" label="着払い番号" width="100" sortable centered>
                  {{props.row.paymentNumber }}
                </b-table-column>
                <b-table-column field="status" label="ステータス" width="100" sortable centered>
                  <span :class="getShippingTagClass(props.row.status)">
                    {{getShipping(props.row.status)}}
                  </span>
                </b-table-column>
                <b-table-column field="instrumentKind" label="機種" width="70" sortable >
                  {{props.row.instrumentKind | getNameFilter(modelList)}}
                </b-table-column>
                <b-table-column field="shippingAddress" label="配送先" width="70" centered>
                  {{props.row.shippingAddress }}
                </b-table-column>
                <b-table-column field="receiverName" label="配送先宛名" width="200" sortable >
                  {{props.row.receiverName }}
                </b-table-column>
                <b-table-column field="receiverAddress" label="配送先住所" sortable >
                  {{props.row.receiverAddress }}
                </b-table-column>
              </template>
          </b-table>
      　</div>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holter/HolterNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {LendingPeriod} from "@/components/mock/base/const.js";

export default {
  name: "HolterShippingList",
  methods: {
    doSearch: function(){
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.checkedRows = []
      this.hasResult = false;
      var excuteApi = this.getHolterDeviceShipmentListPOST;
      var successCallBack = this.getHolterDeviceShipmentListPOSTSuccess;
      var errorCallBack = this.getHolterDeviceShipmentListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterDeviceShipmentListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.status = obj.status && obj.status.length!=0 ? JSON.parse(obj.status) : []
      return client.apis.internalHolter.getHolterDeviceShipmentListPOST({
        body:obj
      });
    },
    getHolterDeviceShipmentListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getHolterDeviceShipmentListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    goPaymentNumberBulkSetting: function(){
      this.$router.push({
        name: "HolterPaymentNumberBulkSetting",
        params: {
          data:this.checkedRows,
          searchConditions: this.searchConditions,
          modelList:this.modelList
        }
      });
    },
    goInvoiceBulkSetting: function() {
      this.$router.push({
        name: "HolterInvoiceBulkSetting",
        params: {
          data:this.checkedRows,
          searchConditions: this.searchConditions,
          modelList:this.modelList
        }
      });
    },
    goInvoiceSheetView: function() {
      var receiptNumber = []
      for(let item of this.checkedRows){
        for(let receipt of item.receiptNumber){
          receiptNumber.push(receipt)
        }
      }
      this.$router.push({
        name: "HolterInvoiceSheetView",
        params: {
          receiptNumberList:receiptNumber,
          searchConditions: this.searchConditions
        }
      });
    },
    goLabel12SheetView: function() {
      var targetData = []
      for(let data of this.checkedRows){
        if(data.sendMedicalInstitutionFlag){
          targetData = targetData.concat(data.patientsName)
        }
      }
      this.$router.push({
        name: "HolterLabel12SheetView",
        params: {
          data:targetData,
          searchConditions: this.searchConditions,
        }
      });
    },
    showShippingDirections: function() {
      this.$router.push({
        name: "HolterShippingDirectionsView",
        params: {searchConditions: this.searchConditions}
      });
    },
    doShipping: function() {
      this.shippingData = []
      for(var i=0; i < this.checkedRows.length; i++){
        this.lendingPeriod = LendingPeriod.holter_fourteen_period;
        var choicesInspectionPeriod = "";
        this.inspectionPeriodList.forEach(ele => {
          if (ele.value == this.checkedRows[i].inspectionPeriod){
            choicesInspectionPeriod = ele.label1
          }
        });
        if (choicesInspectionPeriod && choicesInspectionPeriod.match(/14日/)){
          this.lendingPeriod = LendingPeriod.holter_fourteen_period;
        } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/10日/)){
          this.lendingPeriod = LendingPeriod.holter_tenday_period;
        } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/5日/)){
          this.lendingPeriod = LendingPeriod.holter_fiveday_period;
        } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/24時間/)){
          this.lendingPeriod = LendingPeriod.holter_oneday_period;
        }
        var returnDate = this.getBusinessDay(new Date(), this.lendingPeriod);
        returnDate = this.yyyy_sla_MM_sla_dd(returnDate)

        if(this.checkedRows[i].status == 17){
          continue
        }
        if(!this.checkedRows[i].invoiceNumber || !this.checkedRows[i].paymentNumber){
          this.showErrorMessage("「送り状番号」「着払い番号」が\n未登録の検査情報が含まれています。")
          return
        }
        for(let number of this.checkedRows[i].receiptNumber){
          var req = {
            receiptNumber: number,
            invoiceNumber: this.checkedRows[i].invoiceNumber,
            paymentNumber: this.checkedRows[i].paymentNumber,
            returnDate: returnDate
          }
          this.shippingData.push(req)
        }
      }
      if(this.shippingData.length==0){
        this.showErrorMessage("出荷登録可能な検査情報が選択されていません。")
        return
      }
      var excuteApi = this.setHolterDeviceShipmentPOST;
      var successCallBack = this.setHolterDeviceShipmentPOSTSuccess;
      var errorCallBack = this.setHolterDeviceShipmentPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterDeviceShipmentPOST: function(client) {
      return client.apis.internalHolter.setHolterDeviceShipmentPOST({
        body: this.shippingData
      });
    },
    setHolterDeviceShipmentPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.doSearch());
    },
    setHolterDeviceShipmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var statusList = this.getShippingStatusList()
    statusList.unshift({})
    var modelList = this.getChoiceList(choicesType.holterKind, false);
    modelList.unshift({})
    let inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, true);
    return {
      searchConditions:{
        receiptNumber:"",
        shippingDate:"",
        invoiceNumber:"",
        status:"",
        instrumentKind:"",
        shippingAddress:"",
        receiverName:""
      },
      data : [],
      checkedRows:[],
      isPaginated : true,
      hasResult: false,
      takeOverSearchParams,
      statusList,
      modelList,
      shippingData:[],
      lendingPeriod:LendingPeriod.period,
      inspectionPeriodList: inspectionPeriodList,
    };
  },
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    holterNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}

.result-area {
  width: 1300px;
}
.operation-area {
  width: 1000px;
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
}
.operationButton {
  width:200px;
}
.result-count {
  white-space: nowrap; 
  width: 100px;
}
.result-sub-area {
  display: flex;
  flex-flow: column;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterShippingList.vue